import angular from 'angular';
import fullWidthDashedButton from './fullWidthDashedButton';

export default angular
  .module('components.fullWidthDashedButton', [])
  .component('fullWidthDashedButton', fullWidthDashedButton).name;
